import { render, staticRenderFns } from "./EquippedGlyphs.vue?vue&type=template&id=1876a7ea&scoped=true&"
import script from "./EquippedGlyphs.vue?vue&type=script&lang=js&"
export * from "./EquippedGlyphs.vue?vue&type=script&lang=js&"
import style0 from "./EquippedGlyphs.vue?vue&type=style&index=0&id=1876a7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1876a7ea",
  null
  
)

export default component.exports